module.exports = __webpack_public_path__ + "static/man_w_laptop_last-e636f47e4c3391c5530270697d52d779.svg";